import { useContext } from 'react';
import { ObjectAccessContainer } from '@/containers/ObjectAccess/ObjectAccessContainer';
import { useObjectAccessModal } from '@/components/ObjectAccess/hooks/useObjectAccessModal';
import { BrandLoadingContext, BrandStateContext } from '@/containers/Workspace.Brand/Context';
import { ObjectAccessButton, SkeletonAccess } from '@/components/ObjectAccess/Button';
import { useReadOnlyObjectAccessModal } from '@/components/ObjectAccess';

type Props = unknown;

export const Access = (props: Props) => {
  const isLoading = useContext(BrandLoadingContext);

  return isLoading
    ? <SkeletonAccess />
    : <AccessContainer />;
};

Access.displayName = 'Brand.Header.Access';

const AccessContainer = (props: Props) => {
  const state = useContext(BrandStateContext);

  if (state.capabilities.canManageAccess) {
    return <InteractiveAccess />;
  }

  return <NonInteractiveAccess />;
};

const NonInteractiveAccess = (props: Props) => {
  const state = useContext(BrandStateContext);
  const [toggleAccessModal, ObjectAccessModal] = useReadOnlyObjectAccessModal();

  return (
    <>
      <ObjectAccessButton
        count={state.meta.accessCount}
        onClick={toggleAccessModal} />
      <ObjectAccessContainer objectId={state.object.id} workspaceId={state.object.workspaceId}>
        <ObjectAccessModal />
      </ObjectAccessContainer>
    </>
  );
};

const InteractiveAccess = (props: Props) => {
  const state = useContext(BrandStateContext);
  const [toggleAccessModal, ObjectAccessModal] = useObjectAccessModal();

  return (
    <>
      <ObjectAccessButton
        count={state.meta.accessCount}
        onClick={toggleAccessModal} />
      <ObjectAccessContainer objectId={state.object.id} workspaceId={state.object.workspaceId}>
        <ObjectAccessModal />
      </ObjectAccessContainer>
    </>
  );
};